import { extendTheme } from '@mui/joy';
import { experimental_extendTheme as materialExtendTheme } from '@mui/material/styles';

export const materialTheme = materialExtendTheme({
  colorSchemes: {
    light: {
      palette: {
        primary: {
          main: '#8c7ae6', // Purple color
        },
        secondary: {
          main: '#3E3F5B', // Black color
        },
      },
    },
  },
  typography: {
    fontFamily: '"Inter", "Roboto", "Helvetica", "Arial", sans-serif',
  },
});

export const JoyTheme = extendTheme({});
